import type { SliceCreator } from '../types';

export interface UiSlice {
  /**
   * The mobile navigation sheet. ScrollManager subscribes to this and stops
   * Lenis while it is open, so the page cannot scroll behind the menu.
   */
  isMenuOpen: boolean;

  openMenu: () => void;
  closeMenu: () => void;
  toggleMenu: () => void;
}

export const createUiSlice: SliceCreator<UiSlice> = (set) => ({
  isMenuOpen: false,

  openMenu: () => {
    set({ isMenuOpen: true });
  },

  closeMenu: () => {
    /* Guarded, because every route change calls this unconditionally. */
    set((state) => (state.isMenuOpen ? { isMenuOpen: false } : state));
  },

  toggleMenu: () => {
    set((state) => ({ isMenuOpen: !state.isMenuOpen }));
  },
});
